import { Link } from 'react-router-dom';
import { Zap, ChevronRight } from 'lucide-react';
import { TREND_COLOR, TREND_ICON } from '@/lib/ev-trends';
import type { TrendDirection } from '@/lib/ev-trends';
import { trackEvLeaderboardClick } from '@/lib/analytics';

// April 2026 India EV 2-Wheeler Sales (source: rushlane.com, evindia.online)
// Total: 148,677 units (+61% YoY)
const TOP_BRANDS: { brand: string; units: string; trend: TrendDirection; yoy: string }[] = [
  { brand: 'TVS Motor', units: '37.7K', trend: 'up', yoy: '+96%' },
  { brand: 'Bajaj Auto', units: '32.9K', trend: 'up', yoy: '+72%' },
  { brand: 'Ather Energy', units: '27.0K', trend: 'up', yoy: '+103%' },
  { brand: 'Hero Vida', units: '15.2K', trend: 'up', yoy: '+148%' },
  { brand: 'Ola Electric', units: '12.2K', trend: 'down', yoy: '−39%' },
];

export function EvSalesLeaderboard() {
  return (
    <div className="rounded-2xl border border-border-primary bg-bg-secondary overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-border-primary bg-gradient-to-r from-green-500/5 to-transparent">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-green-500/10">
          <Zap className="h-4 w-4 text-green-500" />
        </div>
        <div>
          <h3 className="font-semibold text-text-primary text-sm">EV 2W Sales India</h3>
          <span className="text-[10px] text-text-tertiary">April 2026 · 148.7K total (+61% YoY)</span>
        </div>
      </div>

      <div className="p-2">
        {TOP_BRANDS.map((row, i) => (
          <div
            key={row.brand}
            className="flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-bg-tertiary transition-colors cursor-pointer"
            onClick={() => trackEvLeaderboardClick('brand_click', row.brand)}
          >
            <span className="flex h-6 w-6 items-center justify-center rounded text-xs font-bold text-text-tertiary bg-bg-tertiary flex-shrink-0">
              {i + 1}
            </span>
            <span className="flex-1 min-w-0 text-sm font-medium text-text-secondary">{row.brand}</span>
            <span className={`text-[10px] ${TREND_COLOR[row.trend]} tabular-nums flex items-center gap-0.5`}>
              <span className="text-[8px]">{TREND_ICON[row.trend]}</span>
              {row.yoy}
            </span>
            <span className="text-xs font-semibold text-text-primary tabular-nums ml-1">{row.units}</span>
          </div>
        ))}
      </div>

      <Link
        to="/ev/india-ev-two-wheeler-market-share"
        className="flex items-center justify-center gap-1 border-t border-border-primary py-3 text-sm font-medium text-primary-500 hover:text-primary-400 transition-colors"
        onClick={() => trackEvLeaderboardClick('cta_click')}
      >
        Full market data
        <ChevronRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
